var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"tm-overlay-badge"},[_c('i',{staticClass:"-bottom"},[_c('i',{staticClass:"-duration"},[_c('i',{staticClass:"t",domProps:{"textContent":_vm._s(_vm.overlayDuration)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }